<form [formGroup]="form">
    <!-- <rask-input [label]="texts.huvudkod" formControlName="huvudkodInternnummer" [readonly]="true"></rask-input> -->
    <rask-textmultiline aid="huvudkodInternnummer" class="col-1" [label]="texts.huvudkod" [value]="koppladeLeverantorer" [tightLabel]="true"></rask-textmultiline>
    <rask-input [label]="texts.adress" formControlName="besokAdress" [readonly]="true"></rask-input>
    <rask-input [label]="texts.ordernummer" formControlName="orderNr" [readonly]="true"></rask-input>
    <rask-radiobutton-group [label]="texts.status" [buttons]="statusButtons" formControlName="status">
    </rask-radiobutton-group>
    <rask-input [label]="texts.from" [value]="getPeriodFrom() | date:'yyyy-MM-dd'" [readonly]="true"></rask-input>
    <rask-input [label]="texts.tom" [value]="getPeriodTom() | date:'yyyy-MM-dd'" [readonly]="true"></rask-input>

    <rask-toggle-panel aid="orderDetaljer" label="Detaljer" [defaultExpanded]="false">
        <ng-container>
            <rask-selector
                class="col-lg-3"
                [label]="texts.ansvarig"
                [minCharacters]="3"
                [reverseLookup]="false"
                [getSelectionFromModel]="setAvtalsAnsvarig"
                [placeholder]="texts.typeaheadText"
                [search]="avtalAnsvarigSearch"
                [viewFormatter]="avtalAnsvarigViewFormatter"
                [formatter]="avtalTypeAheadValueFormatter"
                [itemDisabled]="avtalTypeAheadDisabled"
                formControlName="avtalsansvarig"
                aid="avtalsansvarig">
            </rask-selector>
            <rask-textarea aid="kontaktinformation" class="col-lg-3" [label]="texts.kontakt" [rows]="3" formControlName="kontaktinformation">
            </rask-textarea>
            <rask-input aid="updatedBy" class="col-2" [label]="texts.updatedBy" formControlName="uBy" [readonly]="true"></rask-input>
            <rask-input aid="createdBy" [label]="texts.createdBy" formControlName="iBy" [readonly]="true"></rask-input>
        </ng-container>
    </rask-toggle-panel>
</form>
